import styled, { css } from 'styled-components'
import {
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'

import {
  progressBarColorOptions,
  progressBarSizeOptions,
  progressBarStyleOptions
} from './constants'

export const Container = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`

export const ProgressContainer = styled.div`
  width: ${({ customWidth }) => (customWidth ? `${customWidth}px` : '100%')};
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
`

export const ProgressRoot = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;

  background-color: ${({ color }) => color ?? colorsOptions.greys['grey-10']};

  ${({ size = progressBarSizeOptions.SMALL }) => css`
    ${progressBarStyleOptions[size].bar}
  `}
`

export const ProgressBarHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const ProgressBarFooterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`

export const ProgressBarLabelItem = styled.div`
  color: ${({ color = progressBarColorOptions.primary }) => color};

  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  ${({ size = progressBarSizeOptions.SMALL }) => css`
    ${progressBarStyleOptions[size].text}
  `}
`

export const ProgressIndicatior = styled.div`
  height: 100%;
  width: 100%;
  flex: 1;
  background-color: ${({ color = progressBarColorOptions.primary }) => color};
  transition: all;
`
